import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import getFeatureDecision from '../../../../config';
import { ENABLE_CHEAPEST_DATES } from '../../../../config/constants';
import { makeGetCheapestCombination } from '../../selectors/cheapestDatesSelectors';
import { FLIGHT_VERTICAL } from '../constants/analyticsConstants';
import {
  GRID_SOURCE,
  INBOUND_DIRECTION,
  OUTBOUND_DIRECTION,
} from '../constants/dataTypeConstants';

import { useDateSelection } from './useDateSelection';

import type { State } from '../../selectors/types';

const getCheapestCombination = makeGetCheapestCombination();
export const useDurationAutoSelect = () => {
  const { selectDay } = useDateSelection();
  const cheapestCombo = useSelector((state: State) =>
    getCheapestCombination(state),
  );
  const enableCheapestDates = getFeatureDecision(ENABLE_CHEAPEST_DATES, false);

  useEffect(() => {
    if (enableCheapestDates && cheapestCombo) {
      selectDay(
        cheapestCombo.outboundIndex + 1, // selectDay is 1-based
        OUTBOUND_DIRECTION,
        GRID_SOURCE,
        FLIGHT_VERTICAL,
      );

      selectDay(
        cheapestCombo.inboundIndex + 1, // selectDay is 1-based
        INBOUND_DIRECTION,
        GRID_SOURCE,
        FLIGHT_VERTICAL,
      );
    }
  }, [enableCheapestDates, cheapestCombo, selectDay]);
};
